import { Tabs } from "antd";
import { color } from "src/styles/globals";
import styled from "styled-components";
import { Collapse as SundayCollapse } from "src/components/Collapse/Collapse";
import Image from "next/image";

export const FAQTabs = styled(Tabs)`
  .ant-tabs-nav {
    margin-bottom: 0px;
  }
  .ant-tabs-ink-bar {
    background-color: ${color.carrotOrange03};
  }
  .ant-tabs-tab > div > div {
    color: ${color.charcoal09};
  }
  .ant-tabs-tab-active > div > div {
    color: ${color.carrotOrange03};
  }

  .ant-tabs-tab {
    padding: 16px 0;
  }
`;

export const FAQPanel = styled(Tabs.TabPane)`
  > div:first-child
    > .sunday-component-collapse
    .sunday-component-collapse-header {
    border: none;
  }
`;

export const StyledList = styled.ul`
  padding-inline-start: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Collapse = styled(SundayCollapse)`
  .sunday-component-collapse-header-text {
    flex: auto !important;
  }
`;

export const FAQImageContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 343px;
`;

export const FAQImage = styled(Image).attrs({
  layout: "responsive",
  width: 343,
  height: 120,
})``;
